require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

var fs = require('fs');

var axios = require('axios');

var _require = require('javascript-stringify'),
    stringify = _require.stringify;

var ChartJsImage = /*#__PURE__*/function () {
  "use strict";

  function ChartJsImage(apiKey, accountId) {
    _classCallCheck(this, ChartJsImage);

    this.apiKey = apiKey;
    this.accountId = accountId;
    this.host = 'quickchart.io';
    this.protocol = 'https';
    this.baseUrl = "".concat(this.protocol, "://").concat(this.host);
    this.chart = undefined;
    this.width = 500;
    this.height = 300;
    this.devicePixelRatio = 1.0;
    this.backgroundColor = '#ffffff';
    this.format = 'png';
    this.version = '2';
  }

  _createClass(ChartJsImage, [{
    key: "setConfig",
    value: function setConfig(chartConfig) {
      this.chart = stringify(chartConfig);
      return this;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = parseInt(width, 10);
      return this;
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.height = parseInt(height, 10);
      return this;
    }
  }, {
    key: "setBackgroundColor",
    value: function setBackgroundColor(color) {
      this.backgroundColor = color;
      return this;
    }
  }, {
    key: "setDevicePixelRatio",
    value: function setDevicePixelRatio(ratio) {
      this.devicePixelRatio = parseFloat(ratio);
      return this;
    }
  }, {
    key: "setFormat",
    value: function setFormat(fmt) {
      this.format = fmt;
      return this;
    }
  }, {
    key: "setChartJsVersion",
    value: function setChartJsVersion(version) {
      this.version = version;
      return this;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (!this.chart) {
        return false;
      }

      return true;
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      if (!this.isValid()) {
        throw new Error('You must call setConfig before getUrl');
      }

      var ret = new URL("".concat(this.baseUrl, "/chart"));
      ret.searchParams.append('c', this.chart);
      ret.searchParams.append('w', this.width);
      ret.searchParams.append('h', this.height);

      if (this.devicePixelRatio !== 1.0) {
        ret.searchParams.append('devicePixelRatio', this.devicePixelRatio);
      }

      if (this.backgroundColor !== 1.0) {
        ret.searchParams.append('bkg', this.backgroundColor);
      }

      if (this.format !== 1.0) {
        ret.searchParams.append('f', this.format);
      }

      if (this.version) {
        ret.searchParams.append('v', this.version);
      }

      return ret.href;
    }
  }, {
    key: "getPostData",
    value: function getPostData() {
      var width = this.width,
          height = this.height,
          chart = this.chart,
          format = this.format,
          backgroundColor = this.backgroundColor,
          devicePixelRatio = this.devicePixelRatio,
          version = this.version;
      var postData = {
        width: width,
        height: height,
        chart: chart
      };

      if (format) {
        postData.format = format;
      }

      if (backgroundColor) {
        postData.backgroundColor = backgroundColor;
      }

      if (devicePixelRatio) {
        postData.devicePixelRatio = devicePixelRatio;
      }

      if (version) {
        postData.version = version;
      }

      return postData;
    }
  }, {
    key: "getShortUrl",
    value: function () {
      var _getShortUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var resp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isValid()) {
                  _context.next = 2;
                  break;
                }

                throw new Error('You must call setConfig before getUrl');

              case 2:
                _context.next = 4;
                return axios.post('https://quickchart.io/chart/create', this.getPostData());

              case 4:
                resp = _context.sent;

                if (!(resp.status !== 200)) {
                  _context.next = 9;
                  break;
                }

                throw "Bad response code ".concat(resp.status, " from chart shorturl endpoint");

              case 9:
                if (resp.data.success) {
                  _context.next = 13;
                  break;
                }

                throw 'Received failure response from chart shorturl endpoint';

              case 13:
                return _context.abrupt("return", resp.data.url);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getShortUrl() {
        return _getShortUrl.apply(this, arguments);
      }

      return getShortUrl;
    }()
  }, {
    key: "toBinary",
    value: function () {
      var _toBinary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var resp;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isValid()) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('You must call setConfig before getUrl');

              case 2:
                _context2.next = 4;
                return axios.post('https://quickchart.io/chart', this.getPostData(), {
                  responseType: 'arraybuffer'
                });

              case 4:
                resp = _context2.sent;

                if (!(resp.status !== 200)) {
                  _context2.next = 7;
                  break;
                }

                throw "Bad response code ".concat(resp.status, " from chart shorturl endpoint");

              case 7:
                return _context2.abrupt("return", Buffer.from(resp.data, 'binary'));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function toBinary() {
        return _toBinary.apply(this, arguments);
      }

      return toBinary;
    }()
  }, {
    key: "toDataUrl",
    value: function () {
      var _toDataUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var buf, b64buf;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.toBinary();

              case 2:
                buf = _context3.sent;
                b64buf = buf.toString('base64');
                return _context3.abrupt("return", "data:image/png;base64,".concat(b64buf));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function toDataUrl() {
        return _toDataUrl.apply(this, arguments);
      }

      return toDataUrl;
    }()
  }, {
    key: "toFile",
    value: function () {
      var _toFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(pathOrDescriptor) {
        var buf;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.toBinary();

              case 2:
                buf = _context4.sent;
                fs.writeFileSync(pathOrDescriptor, buf);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function toFile(_x) {
        return _toFile.apply(this, arguments);
      }

      return toFile;
    }()
  }]);

  return ChartJsImage;
}();

module.exports = ChartJsImage;